import {
  Box,
  Paper,
  SxProps,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Theme,
} from "@mui/material";
import { DetailElementType } from "types/common-types";

type EntityDetailsRow = {
  title: string;
  component: JSX.Element;
  type: DetailElementType;
};

type EntityDetailsProps = {
  title?: string;
  details: EntityDetailsRow[];
  sx?: SxProps<Theme>,
};

const EntityDetails = ({ title, details, sx }: EntityDetailsProps) => (
  <>
    {title && <h2>{title}</h2>}
    <Box sx={sx}>
      <TableContainer component={Paper}>
        <Table>
          <TableBody>
            {details.map(({ title, component }, i) => (
              <TableRow key={i}>
                <TableCell component="th" scope="row">
                  {title}
                </TableCell>
                <TableCell>{component}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  </>
);

export default EntityDetails;
